export default "__VITE_ASSET__B2T1DqC1__"